module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Britannia-S1.5816a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Britannia-S1.jpg
// module id = Q2P+
// module chunks = 0